import React from "react";
import { StaticRoutes } from "../routes";
import { useNavigate, Link } from "react-router-dom";
import styles from "./Seniority.module.css";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";
import FeaturesList from "../../components/FeaturesList/FeaturesList";
import PreviewItem from "../../components/PreviewItem/PreviewItem";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import logo from "../../assets/BidProPlusSeniorityLogo.png";
import image from "../../assets/seniority-customize.png";

const Seniority = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
  features = [
    {
      icon: "fa-eye",
      header: "View Your ranking",
      description: "View your Ranking on a Detailed Graph.",
    },
    {
      icon: "fa-chart-bar",
      header: "Compare your Rankings",
      description: "Compare your Rankings to other Fleets.",
    },
    {
      icon: "fa-chart-line",
      header: "View Estimated Seniority",
      description: "View Yearly Retires and Estimate Seniority.",
    },
    {
      icon: "fa-users",
      header: "View Other Pilots",
      description:
        "Access basic info for other users such as age, relative seat seniority, and date of hire.",
    },
  ],
}) => {
  const handleSenBtnClick = () => {
    navigate(StaticRoutes.UPSPricing);
  };
  const navigate = useNavigate();
  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));
  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />

      <div
        className={`${styles.logoImageContainer} container-fluid d-flex justify-content-center align-items-center`}
      >
        <img className={styles.Logo} src={logo} alt="BidPro Product Logo" />
      </div>
      <div className={styles.allContainer}>
        <div className={styles.container}>
          {/* Page Logo */}
          <PageHeader
            showselect={false}
            image={image}
            heading="UPS Airline"
            para="BidPro's newest app, that shows UPS pilot's dynamic seniority and provides advanced metrics on performance."
            firstfooter="Already a UPS pilot with a BidPro account?"
            secondfooter={
              <>
                Click{" "}
                <Link to="https://apps.apple.com/us/app/bidpro-seniority-for-ipa/id1527711444">
                  here
                </Link>{" "}
                to download the Seniority app.
              </>
            }
          />

          {/* Page Header */}
          <div className={styles.row}>
            {/* TODO - Insert ProductHeader after ProductHeader is refactored and recommited */}
          </div>

          {/* Product Features */}
          <div className={styles.row}>
            <FeaturesList features={features} colorBlue={false} />
          </div>

          {/* Product Preview Items */}
          <div className={styles.featureColumn}>
            <div className={styles.row}>
              <PreviewItem
                imgRight={true}
                header={"Light and Dark Modes"}
                description={
                  "View your Seniority in light mode for high readability, or turn on dark mode that is easy on the eyes."
                }
                imgs={[
                  {
                    src: "seniority-light-dark-modes.png",
                    alt: "Light and Dark Modes Image",
                  },
                ]}
              />
            </div>
            <div className={styles.row}>
              <PreviewItem
                imgRight={false}
                header={"Compare Progress"}
                description={
                  "The Seniority app lets you search for other users and see their basic info to compare or share a peek of their info."
                }
                imgs={[
                  {
                    src: "seniority-compare.png",
                    alt: "Compare Progress Image",
                  },
                ]}
              />
            </div>
            <div className={styles.row}>
              <PreviewItem
                imgRight={true}
                header={"Customize Your View"}
                description={
                  "Offering an alternate color scheme and dropdown options that save your spot."
                }
                imgs={[
                  {
                    src: "seniority-customize.png",
                    alt: "Light and Dark Modes Image",
                  },
                ]}
              />
            </div>
          </div>

          {/* Get Started */}
          <div className={styles.callToActionColumn}>
            <h2>Ready to get started?</h2>
            {/* Button */}
            <button className={styles.button} onClick={handleSenBtnClick}>
              SIGN UP
            </button>
          </div>
        </div>
      </div>
      <Footer lists={footerLists} inverse={true} />
    </>
  );
};

export default Seniority;
